<template>
  <div class="module-container">
    <div class="title">证件信息</div>
    <ul class="infos">
      <li class="info-item">
        <div class="name">姓名</div>
        <div class="value">{{ infos.residenceBookletMember.citizenName }}</div>
      </li>
      <li class="info-item">
        <div class="name">性别</div>
        <div class="value">{{ infos.residenceBookletMember.sex }}</div>
      </li>
      <li class="info-item">
        <div class="name">民族</div>
        <div class="value">{{ infos.residenceBookletMember.national }}</div>
      </li>
      <li class="info-item">
        <div class="name">籍贯</div>
        <div class="value">{{ infos.residenceBookletMember.nativePlace }}</div>
      </li>
      <li class="info-item">
        <div class="name">公民身份证号码</div>
        <div class="value">{{ infos.residenceBookletMember.idCard }}</div>
      </li>
      <li class="info-item">
        <div class="name">地址</div>
        <div class="value">{{ infos.residenceBookletMaster.address }}</div>
      </li>
      <li class="info-item">
        <div class="name">文化程度</div>
        <div class="value">{{ infos.residenceBookletMember.educationDegree }}</div>
      </li>
      <li class="info-item">
        <div class="name">婚姻状况</div>
        <div class="value">{{ infos.residenceBookletMember.maritalStatus }}</div>
      </li>
      <li class="info-item">
        <div class="name">何时由何地迁来本市</div>
        <div class="value">{{ infos.residenceBookletMember.whenAndWhereMoveToThisCity }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    infos: {
      type: Object,
      default: () => {
        return {
          residenceBookletMaster: {
            address: ''
          },
          residenceBookletMember: {
            citizenName: '',
            sex: '',
            national: '',
            nativePlace: '',
            idCard: '',
            educationDegree: '',
            maritalStatus: '',
            whenAndWhereMoveToThisCity: ''
          }
        }
      }
    }
  },
  methods: {
    formatSexText(val) {
      if (val == 1) {
        return '男'
      } else if (val == 0) {
        return '女'
      }
    },
    formatEduLevelText(val) {
      if (val == 1) {
        return '小学'
      } else if (val == 2) {
        return '初中'
      } else if (val == 3) {
        return '高中'
      } else if (val == 4) {
        return '本科'
      } else if (val == 5) {
        return '研究生'
      } else if (val == 6) {
        return '硕士'
      } else if (val == 7) {
        return '博士'
      } else if (val == 8) {
        return '中专'
      } else if (val == 9) {
        return '大专'
      } else if (val == 10) {
        return '未知'
      }
    },
    formatMarryStateText(val) {
      if (val == 1) {
        return '已婚'
      } else if (val == 0) {
        return '未婚'
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.module-container {
  padding 30px
  font-family PingFangSC-Semibold, PingFang SC
  font-weight 400
  .title {
    position relative
    height 53px
    font-size 38px
    font-weight 600
    color #333333
    line-height 53px
    padding-left 20px
    z-index 5
    &::before {
      content ''
      position absolute
      left 0
      top 50%
      width 36px
      height 36px
      border-radius 50%
      transform translateY(-50%)
      background linear-gradient(270deg, #DBEBFF 0%, #7DB7FF 100%)
      z-index -1
    }
  }
  .infos {
    .info-item {
      display flex
      justify-content space-between
      align-items center
      padding 30px 0
      font-size 30px
      line-height 42px
      .name {
        width 210px
        margin-right 50px
        color #333333
      }
      .value {
        text-align right
        flex 1
        color #999999
      }
    }
    .info-item+.info-item {
      border-top 1px solid #ECECEC
    }
  }
}
</style>
